import { API_BASE_URL } from '../settings';
import { Company } from '../models/index';
import axios from 'axios';

export const createCompany = company => {
  return axios
    .post(API_BASE_URL + 'companies', Company(company))
    .then(res => res.data)
    .then(res => res.data);
};

export const updateCompany = (companyId, company) => {
  return axios
    .put(API_BASE_URL + 'companies/' + companyId, Company(company))
    .then(res => res.data)
    .then(res => res.data);
};

export const getCompanyById = (companyId) => {
  return axios.get(API_BASE_URL + 'companies/' + companyId)
    .then(res => res.data)
    .then(res => res.data);
}

export const getCompanyLevel = (companyId) => {
  return axios.get(API_BASE_URL + 'companies/' + companyId + '/level')
    .then(res => res.data)
    .then(res => res.data);
}

export const getCompanies = () => {
  return axios
    .get(API_BASE_URL + 'companies')
    .then(res => res.data)
    .then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/services/company.services.js